import { Pagination } from '@mui/material';
import { useAppContext } from 'providers/AppProvider';

interface AdvanceTableCPaginationProps {
  setCurrentPage?: (page: number) => void;
  count?: number;
  page?: number;
  onClick?: (event: React.MouseEvent<HTMLElement>, page: number) => void;
}

const AdvanceTableCPagination = ({
  setCurrentPage = () => {},
  count = 1,
  page = 1,
  onClick = () => {}
}: AdvanceTableCPaginationProps) => {
  const {
    config: { theme }
  } = useAppContext();

  const customStyle = {
    '& .MuiButtonBase-root': {
      fontSize: '0.8rem',
      lineHeight: '1.5rem',
      color: theme === 'dark' ? '#9fa6bc' : '#252C32',
      '&.Mui-selected': {
        color: '#fff',
        borderRadius: '0.375rem',
        backgroundColor: '#8200BF',
        '&:hover': {
          backgroundColor: '#8200BF'
        }
      },
      '&:hover': {
        backgroundColor: '#e3e6ed'
      }
    },
    '& .MuiPaginationItem-ellipsis': {
      color: theme === 'dark' ? '#9fa6bc' : '#252C32' // Ensures dots match dark mode text color
    }
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
    onClick(event as React.MouseEvent<HTMLElement>, value);
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '15px',
        paddingBottom: '16px',
        paddingLeft: '12px'
      }}
    >
      <div style={{ display: 'flex' }}></div>
      <Pagination
        sx={customStyle}
        shape="rounded"
        onChange={handlePageChange}
        count={count}
        page={page}
      />
    </div>
  );
};

export default AdvanceTableCPagination;
